import { render, staticRenderFns } from "./AnnouncementsDetails.vue?vue&type=template&id=53a1546c&"
import script from "./AnnouncementsDetails.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports